import { CardState } from 'components/types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledWrapper = styled(Link)<{ state: CardState }>`
  background: linear-gradient(
    180deg,
    rgba(22, 14, 8, 0) 0%,
    rgba(22, 14, 8, 0.75) 100%
  );
  height: 342px;
  overflow: hidden;
  border-radius: 8px;
  position: relative;
  padding: 40px 32px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  text-decoration: none;
  &:before {
    content: '';
    position: absolute;
    display: ${({ state }) => (state === 'not started' ? 'none' : 'block')};
    bottom: 0;
    right: ${({ state }) => (state === 'complete' ? 0 : '50%')};
    height: 4px;
    width: 100%;
    background: ${({ theme }) => theme.colors.brandColors.coral};
  }
`;

export const StyledImage = styled.img`
  object-fit: cover;
  position: absolute;
  top: 0;
  height: 342px;
  width: 100%;
  z-index: -1;
`;

export const StyledLabel = styled.p`
  font-family: 'Moderat Bold';
  color: ${({ theme }) => theme.colors.textColors.secondaryLight};
  font-size: 1.2rem;
  line-height: 2.4rem;
  text-transform: uppercase;
  text-align: center;
`;

export const StyledHeading = styled.h3`
  color: ${({ theme }) => theme.colors.textColors.primaryLight};
  font-size: 3.6rem;
  line-height: 4rem;
  text-align: center;
  font-family: 'Ivar Fine Light';
  text-shadow: 0px 3px 10px rgba(0, 0, 0, 0.24);
`;

export const StyledDescription = styled.p`
  color: ${({ theme }) => theme.colors.textColors.secondaryLight};
  font-size: 1.4rem;
  line-height: 2rem;
  text-align: center;
  display: none;
  ${({ theme }) => theme.breakPoints.desktop} {
    display: block;
  }
`;

export const StyledVideoPlayButton = styled.div`
  height: 48px;
  width: 48px;
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translateY(-50%) translateX(50%);
  backdrop-filter: blur(8px);
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.breakPoints.desktop} {
    height: 48px;
    width: 48px;
  }
`;
